// extracted by mini-css-extract-plugin
export default {"text":"BecomeContactsDialog_text__pMF0N"};